import * as d3 from "d3";
import { getContainerDimensions } from "@/components/VivoPlots/functions/utils/getContainerDimensions";
import type { configType } from "@/components/VivoPlots/types";
import { rotatedLabelMarginBottom } from "@/components/VivoPlots/functions/utils/categoryAxisLabels";

const BASE_MARGIN_BOTTOM = 60;

export const getPlotDimensions = (
  plotClassName: string,
  plotConfig: configType,
) => {
  const svg = d3.select(`svg.${plotClassName}`);

  const { containerWidth, containerHeight } = getContainerDimensions(
    svg as unknown as d3.Selection<SVGSVGElement, unknown, HTMLElement, any>,
    plotClassName,
  );

  const isHorizontal = plotConfig?.orientation === "horizontal";
  const baseLabelLength = plotConfig?.maxLabelLength || 0;
  const hasSubgroups = plotConfig?.hasSubgroups || false;

  const mainLabelWidth =
    isHorizontal && baseLabelLength > 0
      ? Math.min(baseLabelLength, hasSubgroups ? 18 : 24) * 7 //18 or 24 characters (7px per char)
      : 0;

  const subgroupWidth = isHorizontal && hasSubgroups ? 10 * 7 + 5 : 0; //10 characters (7px per char) + padding between them

  const mainLabelPadding = isHorizontal && hasSubgroups ? 50 : 5;

  const marginLeft =
    isHorizontal && (mainLabelWidth > 0 || subgroupWidth > 0)
      ? 20 + mainLabelPadding + mainLabelWidth + subgroupWidth
      : 50;

  const marginRight = 20;
  const padding = 16;
  const bottomPadding = 2 * padding;
  const width = containerWidth - marginLeft - marginRight - padding * 2;
  const marginTop = 80;

  // Rotated category labels run downwards, so the room they need grows with
  // their length. A fixed margin clips them against the widget edge instead.
  const marginBottom =
    !isHorizontal && plotConfig?.verticalXAxisLabels
      ? rotatedLabelMarginBottom({
          baseMarginBottom: BASE_MARGIN_BOTTOM,
          maxCategoryLabelLength: plotConfig?.maxCategoryLabelLength || 0,
          containerHeightPx: containerHeight,
          reservedHeightPx:
            marginTop + bottomPadding + (plotConfig.showLegend ? 31 : 0),
        })
      : BASE_MARGIN_BOTTOM;

  let height = containerHeight - marginTop - marginBottom - bottomPadding;

  if (plotConfig.showLegend) {
    height -= 31;
  }

  return {
    width,
    height,
    marginLeft,
    marginRight,
    marginBottom,
    marginTop,
    padding,
    bottomPadding,
  };
};
